module.exports = __webpack_public_path__ + "static/media/arrow-upward.84e5e9b6.svg";